module.exports = __webpack_public_path__ + "static/media/menu_bars.57cd7e6a.svg";